import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DailyReport from './DailReport'
import MonthlyReport from './MonthlyReport'
import JobReport from './JobReport'
import OutstandingReport from './OutstandingReport'


const reportsBreadCrumbs: Array<PageLink> = [
  {
    title: 'Reports',
    path: '/reports/dailyreports',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ReportsPage: React.FC = () => {
  return (
    <Switch>
      <Route path='/reports/dailyreports'>
        <PageTitle breadcrumbs={reportsBreadCrumbs}>Daily Collection Reports</PageTitle>
        <DailyReport />
      </Route>
      <Route path='/reports/monthlyreports'>
        <PageTitle breadcrumbs={reportsBreadCrumbs}>Monthly P&L Reports</PageTitle>
        <MonthlyReport />
      </Route>
      <Route path='/reports/jobreport'>
        <PageTitle breadcrumbs={reportsBreadCrumbs}>Job Reports</PageTitle>
        <JobReport />
      </Route>
      <Route path='/reports/outstandingreports'>
        <PageTitle breadcrumbs={reportsBreadCrumbs}>Outstanding Reports</PageTitle>
        <OutstandingReport />
      </Route>
      <Redirect from='/reports' exact={true} to='/reports/dailyreports' />
      <Redirect to='/reports/dailyreports' />
    </Switch>
  )
}

export default ReportsPage